import React from 'react';
import TableCourseDesktop from './Desktop/TableCourse';
import CardCourseMobile from './Mobile/CardCourse';
import WarningMessage from '@/presentation/reusables/WarningMessage';
import CourseScheduleFooter from './CourseScheduleFooter';
import { CourseScheduleInfoProps } from './types';
import { ContainerInfo } from './styled';
import { alertInformation } from './constants';

const CourseScheduleInfo = ({ courses, isMobile }: CourseScheduleInfoProps) => {
  const { styled, message } = alertInformation;

  return (
    <ContainerInfo>
      <WarningMessage styledProps={styled} message={message} />
      {isMobile ? (
        <CardCourseMobile courses={courses} isMobile={isMobile} />
      ) : (
        <TableCourseDesktop courses={courses} isMobile={isMobile} />
      )}
      <CourseScheduleFooter isMobile={isMobile} />
    </ContainerInfo>
  );
};

export default CourseScheduleInfo;
